import axios from '../utils/axiosConfig';
import { LoginCredentials, ForgotPasswordCredentials, AuthResponse } from '../types/auth';

// API_URL artık axiosConfig'den geliyor, hardcoded URL kaldırıldı

export const authService = {
    login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
        try {
            console.log('Login request with:', credentials);
            const response = await axios.post('/api/Auth/login', credentials);
            console.log('Login response:', response.data);

            // Token ve kullanıcı bilgilerini kontrol et
            if (!response.data.token || !response.data.kullaniciID) {
                throw new Error('Invalid response format');
            }

            // localStorage'a kaydet
            localStorage.setItem('user', JSON.stringify(response.data));
            console.log('User data saved to localStorage');

            return response.data;
        } catch (error) {
            console.error('Login error:', error);
            localStorage.removeItem('user'); // Hata durumunda localStorage'ı temizle
            throw error;
        }
    },

    forgotPassword: async (credentials: ForgotPasswordCredentials): Promise<void> => {
        try {
            await axios.post('/api/Kullanicilar/SifremiUnuttum', credentials);
        } catch (error) {
            console.error('Forgot password error:', error);
            throw error;
        }
    },

    logout: (): void => {
        try {
            localStorage.removeItem('user');
            console.log('User logged out, localStorage cleared');
        } catch (error) {
            console.error('Logout error:', error);
        }
    },

    getCurrentUser: (): AuthResponse | null => {
        try {
            const userStr = localStorage.getItem('user');
            console.log('Getting user from localStorage:', userStr);

            if (!userStr) {
                return null;
            }

            const userData = JSON.parse(userStr);
            
            // Gerekli alanların varlığını kontrol et
            if (!userData.token || !userData.kullaniciID) {
                console.warn('Invalid user data in localStorage');
                localStorage.removeItem('user');
                return null;
            }

            return userData;
        } catch (error) {
            console.error('Error getting current user:', error);
            localStorage.removeItem('user');
            return null;
        }
    },

    // Debug için yardımcı fonksiyon
    checkAuthState: (): void => {
        const userStr = localStorage.getItem('user');
        console.log('Current localStorage state:', userStr);
        if (userStr) {
            try {
                const userData = JSON.parse(userStr);
                console.log('Parsed user data:', userData);
            } catch (error) {
                console.error('Error parsing user data:', error);
            }
        }
    }
};